import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce6311f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column mb-3",
  id: "containerCard"
}
const _hoisted_2 = {
  class: "d-flex flex-row justify-content-between pb-8 align-items-center",
  style: {"overflow":"auto"}
}
const _hoisted_3 = {
  class: "d-flex flex-row gap-2",
  id: "btnsInd"
}
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-search-plus" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ListVehicles = _resolveComponent("ListVehicles")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, { style: {"min-width":"13rem"} }, {
        default: _withCtx(() => [
          _createTextVNode("Revisão de veículos")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_select, {
          style: {"width":"10rem"},
          placeholder: "Marca",
          filterable: "",
          clearable: "",
          modelValue: _ctx.marca,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.marca) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayMarcas, (item, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          style: {"width":"10rem"},
          placeholder: "Prioridade",
          filterable: "",
          clearable: "",
          modelValue: _ctx.prioridade,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prioridade) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayPrioridade, (item, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: item,
                value: item
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          style: {"width":"10rem"},
          placeholder: "Quantidade",
          clearable: "",
          modelValue: _ctx.qtd,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.qtd) = $event)),
          type: "number"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_date_picker, {
            style: {"width":"10rem"},
            modelValue: _ctx.startDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
            type: "year",
            format: "YYYY",
            "value-format": "YYYY",
            placeholder: "Data inicial"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_date_picker, {
            style: {"width":"10rem"},
            modelValue: _ctx.endDate,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
            type: "year",
            format: "YYYY",
            "value-format": "YYYY",
            placeholder: "Data Final"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_Button, {
          type: "button",
          text: "Gerar",
          onClick: _cache[5] || (_cache[5] = () => _ctx.gerar()),
          style: {"white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_ListVehicles, {
      loading: _ctx.loadingList,
      arrayVehicles: _ctx.arrayVeiculos
    }, null, 8, ["loading", "arrayVehicles"])
  ]))
}